<app-product-files-prompt [sectionNumber]="3"
                          sectionTitle="Damage Close Up Photo"
                          heroTitle="Great job! Next we’ll need a close up..."
                          heroImage="assets/consumer-mobile/damage-file.svg"
                          messageBody="Take a close up of the damage itself. It should be close enough to show the detail of the damage but not so close that the image is out of focus. Please consider using a ruler or other object to provide scale."
                          (goToNextStep)="goToTagFileUpload()"></app-product-files-prompt>
